import { configs } from "eslint-plugin-prettier";
import React, { createContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getProfilePage, changePassword } from "../../api/Api";
import RouteConstants from "../../constants/routesContent.json";

import { nonEmpty } from "../../utils/service";
export const ProfilePageContext = createContext({});
export const ProfileViewContextProvider = ({ children }) => {
  const [profileData, setProfileData] = useState([]);
  const [modalOpenStatus, setModalOpenStatus] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [PasswordConfirm, setPasswordConfirm] = useState("");
  const [passwordType, setPasswordType] = useState("password");
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [newPasswordType, setNewPasswordType] = useState("password");
  const [confirmPasswordType, setConfirmPasswordType] = useState("password");
  const [newPasswordInvalid, setNewPasswordInvalid] = useState(false);
  const [confirmPasswordInvalid, setConfirmPasswordInvalid] = useState(false);
  const [oldPasswordInvalid, setOldasswordInvalid] = useState(false);
  const [passWordMisMatch, setPasswordMisMatch] = useState(false);
  const [statusCode, setStatusCode] = useState(0);
  const [userImage, setUserImage] = useState("");
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };
  const handleAlertSubmit = () => {
    setShowAlert(false);
  };
  const profileDetail = async () => {
    try {
      const response = await getProfilePage();
      if (response?.data?.status === 200) {
        setProfileData(response?.data?.data?.admin);
        setUserImage(response?.data?.data?.admin[0].Image);
      }
    } catch (error) {
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 401) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 400) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);

        setAlertMessage("Something went wrong");
      }
    }
  };
  const passwordChange = async (oldPassword, newPassword) => {
    if (!oldPassword) {
      setOldasswordInvalid(true);
    } else {
      setOldasswordInvalid(false);
    }
    if (!newPassword) {
      setNewPasswordInvalid(true);
    } else {
      setNewPasswordInvalid(false);
    }
    if (!PasswordConfirm) {
      setConfirmPasswordInvalid(true);
    } else {
      setConfirmPasswordInvalid(false);
    }
    if (
      nonEmpty(newPassword) &&
      nonEmpty(PasswordConfirm) &&
      nonEmpty(oldPassword)
    ) {
      if (newPassword === PasswordConfirm) {
        try {
          const response = await changePassword(oldPassword, newPassword);
          if (response.status === 200) {
            if (newPassword === PasswordConfirm) {
              setAlertMessage("Password Updated Succesfully");
              setShowAlert(true);
              setPasswordMisMatch(false);
              setOldPassword("");
              setNewPassword("");
              setPasswordConfirm("");
              setModalOpenStatus(false);
            }
          }
        } catch (error) {
          const errorMessage = error.response.data.message;
          if (error.response.data.status === 400) {
            setShowAlert(true);
            setAlertMessage("Your old password is incorrect");
          } else if (error?.response?.data?.status === 401) {
            setShowAlert(true);

            setAlertMessage(error?.response?.data?.message);
          } else if (error?.response?.data?.status === 403) {
            setShowAlert(true);
            setAlertMessage(error?.response?.data?.message);
          } else {
            setShowAlert(true);
            setAlertMessage("Somethingwent wrong");
          }
        }
      } else {
        setPasswordMisMatch((prevValue) => !prevValue);
      }
    }
  };

  const popupValueRest = () => {
    setOldPassword("");
    setNewPassword("");
    setPasswordConfirm("");
    setPasswordMisMatch(false);
    setOldasswordInvalid(false);
    setConfirmPasswordInvalid(false);
    setNewPasswordInvalid(false);
  };
  const logout = () => {
    localStorage.removeItem("x-access-token");
    localStorage.removeItem("permissions");
    localStorage.removeItem("remember");
    navigate(RouteConstants.LOGIN);
  };
  const providerValue = {
    goBack,
    profileDetail,
    profileData,
    modalOpenStatus,
    setModalOpenStatus,
    passwordChange,
    popupValueRest,
    oldPassword,
    setOldPassword,
    newPassword,
    setNewPassword,
    PasswordConfirm,
    setPasswordConfirm,
    passwordType,
    setPasswordType,
    showAlert,
    setShowAlert,
    handleAlertSubmit,
    userImage,
    alertMessage,
    newPasswordType,
    setNewPasswordType,
    confirmPasswordType,
    setConfirmPasswordType,
    newPasswordInvalid,
    setNewPasswordInvalid,
    confirmPasswordInvalid,
    setConfirmPasswordInvalid,
    oldPasswordInvalid,
    setOldasswordInvalid,
    passWordMisMatch,
    setPasswordMisMatch,
    logout,
    statusCode,
  };

  return (
    <ProfilePageContext.Provider value={providerValue}>
      {children}
    </ProfilePageContext.Provider>
  );
};
